// Journey 3 — a new SME's first week: get access, work inside your scope, give
// feedback that becomes action, and help push satisfaction past the target.
// Some steps need a role the executive persona lacks (custom fields); RBAC
// filtering simply drops them, and cross-role steps carry a fallbackBody.
import { ANCHORS } from '../../features/tours/tourAnchors.js';

export const j3FirstWeek = {
  id: 'j3-first-week',
  title: 'Your first week',
  minutes: 3,
  steps: [
    {
      id: 'j3-access',
      route: '/access/status',
      routeKey: '/access/status',
      anchor: ANCHORS.accessStatus,
      title: 'Start with access',
      body: 'Your first week starts with access. This page tracks your request through each stage until your roles are approved and the right screens open up.',
      fallbackBody: 'Your access request status appears here once you submit it.',
    },
    {
      id: 'j3-scope',
      route: '/loe-dashboard',
      routeKey: '/loe-dashboard',
      anchor: ANCHORS.loeFilterToolbar,
      title: 'You only see your scope',
      body: 'Once you are in, boards show only the work in your division scope. The filters let you narrow further to the priorities you own.',
      fallbackBody: 'Boards are limited to your division scope, so you only see the work assigned to you.',
    },
    {
      id: 'j3-feedback',
      route: '/feedback/queue',
      routeKey: '/feedback/queue',
      anchor: ANCHORS.feedbackQueue,
      title: 'Feedback becomes action',
      body: 'Spot something wrong on a page? Feedback you leave becomes a tracked item a reviewer can turn straight into an action.',
      fallbackBody: 'The feedback queue is open to reviewers, who turn each note into a tracked action.',
    },
    {
      id: 'j3-custom-field',
      route: '/admin/custom-fields',
      routeKey: '/admin/custom-fields',
      anchor: ANCHORS.customFieldForm,
      title: 'Governed, not rigid',
      body: 'Administrators can add a governed custom field to a form here, so an office captures its own detail without breaking the shared record.',
      fallbackBody: 'Adding a custom field is limited to data stewards and administrators, so most personas will not see this screen.',
    },
    {
      id: 'j3-uat',
      route: '/uat',
      routeKey: '/uat',
      anchor: ANCHORS.uatSatisfaction,
      title: 'Proof it is working',
      body: 'The UAT dashboard tracks how satisfied real users are against the 80% target that signals the tool is ready for daily use.',
      fallbackBody: 'The UAT dashboard tracks user satisfaction against the readiness target.',
    },
  ],
  closingNarrative:
    'By the end of week one you are onboarded, working inside your scope, giving feedback that turns into action, and helping push satisfaction past the target. Onboarded, governed, and productive.',
};
